// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2hym0","inner":"style_inner__1xir4","bottom":"style_bottom__1KXKS","copyright":"style_copyright__1cVOS"};